import { LoadingPage, ResponsiveMenuLayout, Typography } from "@fideus-ui/core";
import { type ReactNode, Suspense } from "react";
import { ServiceMenu } from "./ServiceMenu";

export function ServiceLayout({
  children,
  topBar,
}: {
  children: ReactNode;
  topBar?: ReactNode;
}) {
  return (
    <ResponsiveMenuLayout
      title={<Typography variant="h4">Service</Typography>}
      topBar={topBar}
      menu={<ServiceMenu />}
      titleInverted="Service"
    >
      <Suspense fallback={<LoadingPage />}>{children}</Suspense>
    </ResponsiveMenuLayout>
  );
}
